export default "__VITE_ASSET__B6rHvv$9__"